import React from "react";
import ReactDOM from "react-dom";
// import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { store, persistor } from "./Redux/index";
import { createBrowserHistory} from 'history';
// import store from "./store";
import { get } from 'lodash';
import { loadState } from './store/LocalStorage';
import configureStore from './store/configureStore'
const history = createBrowserHistory();
const { loggedIn , userinfo , responce , token} = get(loadState(), "auth") || {};

let auth= { 
  loggedIn: loggedIn || false,
  userinfo: userinfo || [],
  token : token,
  responce: responce
 
}
const store = configureStore({...window.__PRELOADED_STATE__,auth:auth}  , history);


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);


reportWebVitals();
